import { GridSizeType, GameTileProps } from './types';
export const selectProperStyles = (
  style: {
    small: string | string[];
    medium: string | string[];
    default: string | string[];
  },
  size?: GridSizeType
) => {
  switch (size) {
    case 'small':
      return style.small;
    case 'medium':
      return style.medium;
    default:
      return style.default;
  }
};

export const prepareGameList = (
  gameList?: Array<GameTileProps | undefined>,
  expectedAmount?: number
) =>
  [...(gameList || []), ...new Array(expectedAmount)].slice(0, expectedAmount);
